import { DSCardWrapper } from "@components/design-system/molecules";

const TeamDefaultModalExplanationCard = ({ title, message }) => {
  return (
    <DSCardWrapper
      variant="info"
      padding="p-sm"
      dataTestId="team-default-explanation-card"
    >
      <p className="text-xs text-brand">
        <strong>{title}</strong> {message}
      </p>
    </DSCardWrapper>
  );
};

export default TeamDefaultModalExplanationCard;
